/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ResourceHelper} from '../../../util/resource-helper';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

function transformResponse(product: any): any {
  if (_.isPlainObject(_.get(product, 'data'))) {
    product.data = _.mapValues(product.data, (value: any) => {
      if (!_.isString(value)) {
        return value;
      }
      try {
        return JSON.parse(value);
      } catch (_err) {
        return value;
      }
    });
  }
  return product;
}

/** Angular DI token for the Product HTTP resource (factory product). */
export class ProductResource {
}

export function createProductResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const transformRequest = function(product: any) {
    ['minimumBudget', 'maximumBudget', 'minimumCpm'].forEach(fieldName => ResourceHelper.checkMoney(product, [fieldName]));
    const transformed = _.cloneDeep(product);
    if (_.isPlainObject(transformed.data)) {
      transformed.data = _.mapValues(transformed.data, (value: any) => _.isObject(value) ? JSON.stringify(value) : value);
    }
    return transformed;
  };
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'product',
    () => localUserProfile,
    undefined,
    undefined,
    {transformRequest, transformResponse}
  );
}

export const productResourceProvider = {
  provide: ProductResource,
  useFactory: createProductResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

